import React from 'react'
import styled from 'styled-components'
import { VizElement } from 'components/VizElement'
import useDimensions from 'hooks/useDimensions'

const sizeMod = 0.9

const Container = styled.div<{ baseWidth: number }>`
  line-height: 0;
  margin-bottom: 10px;
  margin-left: 0px;
  margin-right: 0px;
  flex: ${props => '0 0 ' + props.baseWidth + '%'};
`
const Label = styled.div`
  font-family: var(--chart-font-stack);
  width: 100%;
  text-align: center;
  line-height: 1.2em;
  font-size: 15px;
  &.bold {
    font-weight: 700;
    text-transform: uppercase;
  }
`
const Triangle = styled.div`
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid black;
  margin-top: 3em;
  margin: 0 auto;
`
const SVG = styled.svg<{ size: number }>`
  width: ${100 * sizeMod}%;
  margin-left: ${(100 - 100 * sizeMod) / 2}%;
  height: ${props => props.size + 'px'};
  margin-bottom: 0px;
`

export const CantonsViz = ({
  data,
  elementsPerRow = 1,
  setHoveredElement,
  isImportant = false
}: {
  data: { label: string; id: string; colors: { [K in indicatorTypes]: string } }
  elementsPerRow?: number
  setHoveredElement?: any
  isImportant: boolean
}) => {
  const { label, colors } = data
  const [REF, size, node] = useDimensions()
  const widthPercent = 100 / elementsPerRow
  const moddedWidth = size.width * sizeMod

  return (
    <Container
      ref={REF}
      className='CantonsVizContainer'
      baseWidth={widthPercent}
    >
      {size && (
        <SVG
          size={moddedWidth * 0.9}
          onMouseMove={e => {
            const rect = e.currentTarget?.parentNode?.parentNode.parentNode.getBoundingClientRect()
            const x = e.pageX - rect.left + 10
            const y = e.nativeEvent.y - rect.top + 10
            setHoveredElement({ code: data.id, pos: { x, y } })
          }}
          onMouseLeave={() => {
            setHoveredElement(undefined)
          }}
        >
          <VizElement
            x={moddedWidth / 2}
            y={moddedWidth / 2}
            colors={colors}
            rad={moddedWidth / 8}
          />
        </SVG>
      )}
      <Label className={isImportant ? 'bold' : ''}>
        {label} {isImportant && <Triangle />}
      </Label>
    </Container>
  )
}
